import { render, staticRenderFns } from "./ProductsOverLimitWithLegacySubscriptionBanner.vue?vue&type=template&id=60b3a407"
import script from "./ProductsOverLimitWithLegacySubscriptionBanner.vue?vue&type=script&lang=js"
export * from "./ProductsOverLimitWithLegacySubscriptionBanner.vue?vue&type=script&lang=js"
import style0 from "./ProductsOverLimitWithLegacySubscriptionBanner.vue?vue&type=style&index=0&id=60b3a407&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports